import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { Color, FontWeight, Grid, Media, Spacing } from '../../theme';
import { hexToRgba, styleWhenTrue } from '../../utils';

import { DotData, SlideItemData } from './productPageHeader.types';

export const Container = styled.div`
  max-width: ${Grid.DesktopWide};
  margin: 0 auto;
  position: relative;
`;

export const InnerContainer = styled.div`
  padding: 170px ${Spacing.DesktopWide};
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: ${Grid.DesktopNarrow};
  ${Media.desktop`
    padding: 170px ${Spacing.Desktop};
  `}
  ${Media.tablet`
    flex-direction: column;
    padding: 130px ${Spacing.Tablet};
  `}
`;

export const SliderColumn = styled.div`
  position: relative;
  width: 50%;
  height: 100%;
  min-height: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${Media.tablet`
    width: 100%;
  `}
`;

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  ${Media.tablet`
    width: 100%;
  `}
`;

export const Header = styled.h1`
  color: ${Color.darkGrey};
  font-size: 50px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 55px;
`;

export const Subheader = styled.div`
  display: flex;
  align-items: center;
  margin: 22px 0 30px;
`;

export const SubheaderLabel = styled.div`
  color: ${Color.veryLightGrey};
  font-size: 12px;
  font-weight: ${FontWeight.Bold};
  letter-spacing: 0.92px;
  line-height: 15px;
  text-transform: uppercase;
`;

export const SubheaderValue = styled(SubheaderLabel)`
  color: ${Color.primary};
  margin-left: 15px;
`;

export const Description = styled.div`
  color: ${Color.darkGrey};
  font-size: 18px;
  font-weight: ${FontWeight.Light};
  letter-spacing: 0;
  line-height: 32px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 40px;
  div + div {
    margin-left: 5px;
  }
`;

export const SlideItem = styled.div<SlideItemData>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.5s;
  ${styleWhenTrue(prop('active'), css`
    opacity: 1;
  `)}
`;

export const SlidePhoto = styled.img`
  max-height: 360px;
  max-width: 275px;
  width: 100%;
  height: 100%;
`;

export const HalfBox = styled.div`
  width: 50%;
  background-color: ${Color.veryLightGrey2};
  height: 45px;
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
`;

export const Dot = styled.div<DotData>`
  height: 10px;
  width: 10px;
  background-color: ${Color.mediumLightGrey};
  border-radius: 50%;
  transition: background-color 0.3s;
  & + & {
    margin-top: 10px;
  }
  ${styleWhenTrue(prop('active'), css`
    background-color: ${Color.primary};
  `)}
`;

export const ClassicButton = styled.div`
  width: calc(50% - 2.5px);
  a {
    padding: 20px 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${Color.mediumLightGrey};
    background-color: ${Color.white};
    text-decoration: none;
    color: ${Color.darkGrey};
    font-size: 15px;
    font-weight: ${FontWeight.Medium};
    letter-spacing: 0;
    transition: opacity 0.3s;
    &:hover {
      opacity: 0.7;
    }
  }
`;

export const ActionButton = styled(ClassicButton)`
  a {
    box-shadow: 0 2px 10px 0 ${hexToRgba(Color.primary, 0.25)};
    background-color: ${Color.primary};
    color: ${Color.white};
  }
`;
